const KCAL_TO_KJ_RATIO = 4.184

export {
  KCAL_TO_KJ_RATIO
}